import gql from "graphql-tag";

export const EQUIPMENT_SUBCATEGORIES_FULL_LIST = gql`
  query equipmentSubcategoriesFullList {
    equipmentSubcategoriesFullList
  }
`;